import { config } from "config";
import { useEffect, useMemo, useState } from "react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";

import { Loader } from "@livechat/design-system-react-components";

import { SafeIframe } from "components/safe-iframe/SafeIframe";
import { newFeaturesCampaigns } from "constants/campaigns";
import { useNewFeatureForAgents } from "hooks/use-new-feature-for-agents";
import { ApplicationsActions } from "store/entities/applications";
import { selectIsGhostLogin } from "store/features/session";

import { PostMessageEvent } from "./constants";
import { iframeWrapperCss, loaderWrapperCss } from "./styled";

const Marketplace: React.FC = () => {
  const isGhost = useSelector(selectIsGhostLogin);
  const [isLoading, setIsLoading] = useState(!isGhost);

  const { isNewForAgent, featureFlagValue, setAgentFlagCallback } = useNewFeatureForAgents(
    newFeaturesCampaigns.hasSeenMarketplace.flag,
    newFeaturesCampaigns.hasSeenMarketplace.campaignStartDate
  );

  const location = useLocation();
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const markMarketplaceAsSeen = () => {
    if (isNewForAgent && !featureFlagValue) {
      setAgentFlagCallback();
    }
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const setIsReadyToDisplay = () => {
    setIsLoading(false);
    markMarketplaceAsSeen();
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const receivePostMessage = (event: MessageEvent) => {
    if (event.origin !== config.helpdeskMarketplaceLink) {
      return;
    }

    try {
      const { event_data, event_name } = JSON.parse(event.data);

      switch (event_name) {
        case PostMessageEvent.AppRemoved:
        case PostMessageEvent.AppInstalled: {
          dispatch(ApplicationsActions.fetchInstalledApps());
          break;
        }

        case PostMessageEvent.RouteChange: {
          history.replace(event_data.pathname);
          break;
        }

        case PostMessageEvent.Loaded: {
          setIsReadyToDisplay();
          break;
        }

        case PostMessageEvent.Navigate: {
          const { pathname } = event_data;

          if (pathname) {
            history.push(pathname);
          }
          break;
        }

        default: {
          break;
        }
      }
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      // do nothing in case event data is already object or it cannot be parsed
    }
  };

  const marketplaceUrl = useMemo(() => {
    let url = config.helpdeskMarketplaceLink;

    // add parameters after /marketplace to the url
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (params[0]) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      url += params[0];
    }

    // pass all extra data from url like UTMs to the marketplace
    if (location?.search) {
      url += location?.search;
    }

    return url;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener("message", receivePostMessage);

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      window.removeEventListener("message", receivePostMessage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading && (
        <div css={loaderWrapperCss}>
          <Loader />
        </div>
      )}

      <div css={iframeWrapperCss}>
        <SafeIframe onLoad={setIsReadyToDisplay} src={marketplaceUrl} aria-label="Marketplace" />
      </div>
    </>
  );
};

export default Marketplace;
